<div [formGroup]="form" [ngClass]=AppConfig.theme>
  <ng-container [ngSwitch]="question.controlType">
    <ng-container *ngSwitchCase="'textbox'">
      <mat-form-field class="w-100 h4">
        <input matInput [formControlName]="question.key" [id]="question.key" [type]="question.type" [placeholder]="question.label" [required]="question.required">
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'textarea'">
      <mat-form-field class="w-100 h4">
        <textarea matInput [formControlName]="question.key" [id]="question.key" [type]="question.type" [placeholder]="question.label" [required]="question.required"></textarea>
          <mat-hint *ngIf="!isValid">{{ question.label }}을 입력해야 합니다</mat-hint>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'select'">
      <mat-select class="w-100" [(ngModel)]="question.selected.value" [placeholder]="question.label" [formControlName]="question.key" [required]="question.required">
        <mat-option *ngFor="let option of question.options" [value]="option.value">{{ option.label }}</mat-option>
      </mat-select>
    </ng-container>
  </ng-container>
</div>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/dynamic-form-question/dynamic-form-question.component.html